var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.query.dataType==10239001)?_c('CloudMarketAppInfo'):_vm._e(),(_vm.$route.query.dataType==10239004)?_c('CloudMarketSolutionDetails'):_vm._e(),(_vm.$route.query.dataType==10239002)?_c('CloudMarketServiceCentreDetails'):_vm._e(),(_vm.$route.query.dataType==10239003)?_c('CloudMarketHardwareMallDetails'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }